<template>
	<div>
		<div v-if="!dialogVisible">
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">工资汇总表</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

					<el-row style="padding-left: 46px; padding-top: 40px;">

						<el-col :span="5">
							<span>日期</span>
							<el-date-picker v-model="condition.years_date" type="month" placeholder="请选择"
								value-format="yyyy-MM" style="margin-left: 10px;">
							</el-date-picker>
						</el-col>
						<el-col :span="2">
							<el-button
								style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
								@click="Find">
								查询</el-button>
						</el-col>
						<el-col :span="3">
							<download-excel class="export-excel-wrapper" :fields="download_excel" name="工资汇总表"
								:fetch="ExportForm" style="">
								<el-button
									style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
									导出</el-button>
							</download-excel>
						</el-col>
					</el-row>

					<el-row style="margin: 0px 2%; margin-top: 20px;">
						<el-row style="margin-top: 10px;">
							<el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" :border="true"
								:row-class-name="tableRowClassName" ref="table" :data="tableData" show-summary
								:summary-method="getSummaries" height="600" tooltip-effect="dark" style="width: 100%;"
								@selection-change="handleSelectionChange">
								<el-table-column type="selection" align="center" width="55">
								</el-table-column>
								<el-table-column align="center" label="序号" width="50">
									<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
								</el-table-column>
								<el-table-column prop="organize_name" align="center" label="项目名称" width="200">
								</el-table-column>
								<el-table-column align="center" label="收入">
									<el-table-column prop="invoiced_amount" align="center" label="开发票金额" width="120">
									</el-table-column>
									<el-table-column align="center" label="开票明细">
										<el-table-column prop="wage_quota" align="center" label="工资定额" width="100">
										</el-table-column>
										<el-table-column prop="contract_amount" align="center" label="合同金额" width="100">
										</el-table-column>
										<el-table-column prop="quota_proportion" align="center" label="定额占比"
											width="100"></el-table-column>
									</el-table-column>
								</el-table-column>
								<el-table-column align="center" label="工资明细">
									<el-table-column prop="number_of_investors" align="center" label="开资人数" width="120">
									</el-table-column>
									<el-table-column prop="payroll_payable" align="center" label="开资表应发工资" width="120">
									</el-table-column>
									<el-table-column prop="personal_part_of_social_security" align="center"
										label="社保个人部分" width="120"></el-table-column>
									<el-table-column prop="accumulation_fund_deduction" align="center" label="公积金扣款"
										width="120"></el-table-column>
									<el-table-column prop="accident_insurance_deduction" align="center" label="意外保险扣款"
										width="120"></el-table-column>
									<el-table-column prop="clothing_deposit" align="center" label="服装押金" width="120">
									</el-table-column>
									<el-table-column prop="payroll_actual_salary" align="center" label="工资表实发工资"
										width="120"></el-table-column>
								</el-table-column>
								<el-table-column prop="proportion_wages" align="center" label="工资占比">
									<template slot-scope="scope">
										<span>{{ scope.row.proportion_wages }}%</span>
									</template>
								</el-table-column>
								<el-table-column prop="remarks" align="center" label="备注" width="200"></el-table-column>
								<el-table-column align="center" label="状态" width="150">
									<template slot-scope="scope">
										<img src="../../../assets/待审批.png" v-show="scope.row.spare5 === '0'" />
										<img src="../../../assets/已同意.png" v-show="scope.row.spare5 === '1'" />
									</template>
								</el-table-column>
							</el-table>
						</el-row>
						<!-- <el-row style="margin-top: 10px; text-align: center;">
                            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                                layout=" prev, pager, next, jumper" :total="total">
                            </el-pagination>
                        </el-row> -->
					</el-row>

				</div>
			</el-row>
		</div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	components: {},
	data() {
		return {
			//列表相关
			page_num: 1,
			page_size: 10,
			total: 0,
			tableData: [],
			ids: [],

			//页面相关
			dialogVisible: false,

			//职位下拉
			postList: [],

			//条件
			condition: {
				years_date: this.$globals.getNowTimes(),
			},

			//详情
			from: {

			},
			download_excel: {
				"项目名称": "organize_name",
				"开发票金额": "invoiced_amount",
				"工资定额": "wage_quota",
				"合同金额": "contract_amount",
				"定额占比": "quota_proportion",
				"开资人数": "number_of_investors",
				"工资表应发工资": "payroll_payable",
				"社保个人部分": "personal_part_of_social_security",
				"意外保险扣款": "accident_insurance_deduction",
				"服装押金": "clothing_deposit",
				"工资表实发工资": "payroll_actual_salary",
				"备注": "remarks",
			},

			//复选框ids
			ids: [],
		};
	},
	// 合计
	updated() {
		this.$nextTick(() => {
			this.$refs['table'].doLayout();
		})
	},
	methods: {
		// 全选
		handleSelectionChange(e) {
			this.ids = [];
			e.forEach(item => {
				this.ids.push(item.id);
			});
		},
		Return() {
			this.dialogVisible = false;
		},
		//指定列求和
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '合计';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (column.property == 'invoiced_amount' || column.property == 'wage_quota' || column.property == 'post_salary' || column.property == 'contract_amount'
					|| column.property == 'quota_proportion' || column.property == 'payroll_payable' || column.property == 'personal_part_of_social_security' || column.property == 'accident_insurance_deduction'
					|| column.property == 'clothing_deposit' || column.property == 'payroll_actual_salary') {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
					// console.log(sums )
					// sums[index];
					sums[index] = sums[index].toFixed(2); //保留2位小数
				}
			});
			return sums
		},
		//查询
		Find() {
			const url = this.$globals.http + "SummaryTable/selectAll";
			axios.post(url, {
				// page_num: this.page_num,
				// page_size: this.page_size,
				years_date: this.condition.years_date + '-01',
				applicant_id: this.$globals.user.staff_id,
			}).then((response) => {
				var code = response.data.code;
				var data = response.data.data;
				if (code === '200') {
					this.tableData = data;
					this.total = data.total;
				} else {
					this.$message.warning("请求失败！请稍后重试");
				}
			}).catch((error) => {
				console.log(error)
				this.$message.error("服务器未响应！请稍后重试");
			})
		},
		//导表
		async ExportForm() {

			var url = 'SummaryTable/selectAll';
			var record = {
				years_date: this.condition.years_date + '-01',
				applicant_id: this.$globals.user.staff_id,
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					if (data.length > 0) {
						this.$message.success("导表成功！文件下载中！");
						return data;
					} else {
						this.$message.success("没有可以导出的数据！");
						return null;
					}

				}
			}
		},
		//审批
		async examine(e) {
			var ids;
			if (e === null || e === "" || e === undefined) {
				if (this.ids === null || this.ids.length <= 0) {
					this.$message.warning("请先选择操作数据！");
					return false;
				}
				ids = this.ids;
			} else {
				ids = [e];
			}

			var url = "SummaryTable/Examine";
			var record = {
				ids: ids,
				years_date: this.condition.years_date + '-01',
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === "-2000") {
				this.$message.error("服务器未响应！请稍后重试");
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
					this.trash();
					this.Find();
				} else {
					this.$message.warning(data);
				}
			}
		},
		//分页
		handleCurrentChange(val) {
			this.page_num = val
			this.Find();
		},

	},
	async created() {
		this.Find();
		//初始化职位下拉
		var postList = await this.$globals.AxiosPost("post/selectFind", {});
		this.postList = postList.data;
	}
}
</script>

<style scoped="scoped">
>>>.el-button:hover {
	background-color: #FFFFFF;
}

>>>.el-button:focus {
	background-color: #FFFFFF;
}

>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #006E4B;
}

>>>.el-input__inner:focus {
	border-color: #006E4B;
}

>>>.el-select .el-input.is-focus .el-input__inner {
	border-color: #006E4B;
}

>>>.el-checkbox__input.is-checked .el-checkbox__inner,
>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #006E4B;
	border-color: #006E4B;
}

>>>.el-checkbox__inner:hover {
	border-color: #006E4B;
}
</style>



// WEBPACK FOOTER //
// GzHz.vue?0897f7ec